import { GRADE_OPTIONS } from 'app2/api'

export const gradeOptions = GRADE_OPTIONS.map(info => ({
  label: info.text,
  value: info.value
}));
